<template>
    <div class="d-flex flex-column">
        <h2 class="p-3 border-bottom-light">Rules</h2>

         <div v-if="loadingPage" class="d-flex justify-content-center align-items-center vh-100">
            <div class="d-flex flex-column justify-content-center black mt-0">
                 <div class="d-flex flex-column justify-content-center align-items-center vh-100">
                    <span class="dark bold loading">Loading</span>
                    <loader></loader>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-center align-items-center vh-100" v-if="!hasDynamicPricingRevenuePlugin && !loadingPage">
            <div class="d-flex flex-column justify-content-center subscription-msg panel bg-lightest black mt-0">
                <div class="w-100 font-weight-600"><span class="fs-largest">Pricing Rules</span></div>

                <div class="px-0 pb-5 pt-4 w-100">
                    <span>The Pricing Rules functionality is currently <strong>disabled</strong> on your account.</span>
                    <span>To take advantage of its benefits and optimize your pricing and sales channel management,
                        you’ll need to activate the add-on.</span>
                </div>

                <div class="d-flex justify-content-end flex-wrap">
                    <button class="btn btn-learn-more bold pointer ml-3 text-nowrap m-0"
                        :class="{ 'disabled notAllowed': !true }" :disabled="!true" @click="openLearnMoreModal()">
                        <span>Learn more</span>
                    </button>
                    <button type="button" class="btn" :class="{ 'disabled notAllowed': !true }" :disabled="!true"
                        @click="execute()">
                        <span>Activate</span>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="hasDynamicPricingRevenuePlugin && !loadingPage" class="content" id="rule-tabs">
            <tabs>
                <tab name="Rules Group">
                    <tabRulesGroup></tabRulesGroup>
                </tab>
                <tab name="Rules">
                    <tabRules></tabRules>
                </tab>
            </tabs>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import Loader from '@/tools/loaders/loader1'
    import tabRules from './rules/TabRules'
    import tabRulesGroup from './rules/TabRulesGroup'

    export default {
        data() {
            return {
                loadingPage: true,
            }
        },
        created() {
            const afterPluginsLoaded = () => {
                if (this.hasDynamicPricingRevenuePlugin) {
                    this.downloadRules();
                    this.downloadRulesGroup();
                }
                
                this.loadingPage = false;
            };

            if (this.getSubscribedPlugins.length === 0) {
                this.donwloadSubscribedPlugins().then(afterPluginsLoaded);
            } else {
                afterPluginsLoaded();
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedSubscription',
                'getSubscribedPlugins',
                'getSubscriptionCards',
                'getHasDynamicPricingRevenuePlugin',
                'getSubscribedPlugins'
            ]),
            subscriptionCards() {
                return this.getSubscriptionCards;
            },
            hasDynamicPricingRevenuePlugin() {
                return this.getHasDynamicPricingRevenuePlugin;
            }
        },
        methods: {
            ...mapActions([
                'downloadRules',
                'downloadRulesGroup',
                'openModal',
                'setCardSubscription',
                'donwloadSubscribedPlugins'
            ]),
            execute() {
                this.setCardSubscription(this.subscriptionCards.find(e => e.codeName === 'DynamicPricingRevenue'));
                this.openModal('Subscriptions');
            },
            openLearnMoreModal() {
                this.openModal('PricingRulesLearnMore');
            }
        },
        components: {
            Loader,
            tabRulesGroup,
            tabRules
        }
    }
</script>

<style lang="scss" scoped>
    .loading {
        font-size: 30px;
        margin-bottom: 20px;
    }

    .subscription-msg {
        margin: 0 auto;
        max-width: 25rem;
        width: 100%;
        min-height: 15.625rem;
        box-shadow: 0 0.125rem 0.5rem rgba(0, 0, 0, 0.06);
        border-radius: 0.5rem;
        padding: 2rem 1.5rem;
    }

    .subscription-msg .btn+.btn {
        margin-left: 1.5em;
    }

    .btn-learn-more {
        background: none;
        border: none;
        color: #00a9f0;
        text-decoration: underline;
    }

    .btn-learn-more:hover {
        color: #0084bc;
    }
</style>

<style lang="scss">
    #rule-tabs>.tabs-component>.tabs-component-tabs {
        display: block;
    }

    #rule-tabs>.tabs-component>.tabs-component-tabs>.tabs-component-tab>.tabs-component-tab-a {
        padding: 0em 2.5em;
    }
</style>



// WEBPACK FOOTER //
// Rules.vue?5f1f4cf5